import createAction from '../services/create-action';

export const SET_ROUTER_MATCH = 'router/SET_MATCH';

export const setRouterMatch = createAction(SET_ROUTER_MATCH);
